// material-ui
import type { SlideProps } from '@mui/material'

import type { SyntheticEvent } from 'react'
// types
import type { KeyedObject } from 'types/root'
// assets
import { CloseOutlined } from '@ant-design/icons'

import { Alert, Button, Fade, Grow, Slide } from '@mui/material'
import MuiSnackbar from '@mui/material/Snackbar'

import { closeSnackbar, useGetSnackbar } from 'api/snackbar'

// project import
import IconButton from './IconButton'

// animation function
function TransitionSlideLeft(props: SlideProps) {
  return <Slide {...props} direction="left" />
}

function TransitionSlideUp(props: SlideProps) {
  return <Slide {...props} direction="up" />
}

function TransitionSlideRight(props: SlideProps) {
  return <Slide {...props} direction="right" />
}

function TransitionSlideDown(props: SlideProps) {
  return <Slide {...props} direction="down" />
}

function GrowTransition(props: SlideProps) {
  return <Grow {...props} />
}

// animation options
const animation: KeyedObject = {
  SlideLeft: TransitionSlideLeft,
  SlideUp: TransitionSlideUp,
  SlideRight: TransitionSlideRight,
  SlideDown: TransitionSlideDown,
  Grow: GrowTransition,
  Fade,
}

// ==============================|| SNACKBAR ||============================== //

function Snackbar() {
  const { snackbar } = useGetSnackbar()

  const handleClose = (event: SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }
    closeSnackbar()
  }

  return (
    <>
      {/* default snackbar */}
      {snackbar.variant === 'default' && (
        <MuiSnackbar
          anchorOrigin={snackbar.anchorOrigin}
          open={snackbar.open}
          autoHideDuration={1500}
          onClose={handleClose}
          message={snackbar.message}
          TransitionComponent={animation[snackbar.transition]}
          action={
            <>
              <Button color="secondary" size="small" onClick={handleClose}>
                UNDO
              </Button>
              <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose} sx={{ mt: 0.25 }}>
                <CloseOutlined />
              </IconButton>
            </>
          }
        />
      )}
      {/* alert snackbar */}
      {snackbar.variant === 'alert' && (
        <MuiSnackbar
          TransitionComponent={animation[snackbar.transition]}
          anchorOrigin={snackbar.anchorOrigin}
          open={snackbar.open}
          autoHideDuration={1500}
          onClose={handleClose}
        >
          <Alert
            variant={snackbar.alert.variant}
            color={snackbar.alert.color}
            action={
              <>
                {snackbar.actionButton !== false && (
                  <Button color={snackbar.alert.color} size="small" onClick={handleClose}>
                    UNDO
                  </Button>
                )}
                {snackbar.close && (
                  <IconButton
                    sx={{ mt: 0.25 }}
                    size="small"
                    aria-label="close"
                    variant="contained"
                    color={snackbar.alert.color}
                    onClick={handleClose}
                  >
                    <CloseOutlined />
                  </IconButton>
                )}
              </>
            }
            sx={{
              ...(snackbar.alert.variant === 'outlined' && {
                bgcolor: 'grey.0',
              }),
            }}
          >
            {snackbar.message}
          </Alert>
        </MuiSnackbar>
      )}
    </>
  )
}

export default Snackbar
